import { combineEpics } from 'redux-observable'
import { getMeetingVideoDetailsEpic } from 'components/features/coaching/advisorVideoCall/epics/getMeetingVideoDetailsEpic'
import { finishMeetingEpic } from 'components/features/coaching/advisorVideoCall/epics/finishMeetingEpic'
import { wsLogsEpic } from 'components/features/coaching/advisorVideoCall/epics/wsLogsEpic'

export const advisorVideoCallEpic = combineEpics(
  getMeetingVideoDetailsEpic,
  finishMeetingEpic,
  wsLogsEpic,
)
